import { useState } from "react";
import { OrganizationItem } from "./OrganizationItem";
import { RenameItemDialog } from "./RenameItemDialog";
import { DeleteItemDialog } from "./DeleteItemDialog";

interface Organization {
  id: string;
  name: string;
  workspaces: Array<{
    id: string;
    name: string;
    boards: Array<{
      id: string;
      name: string;
    }>;
  }>;
}

interface ManageWorkspaceContentProps {
  organizations: Organization[];
  onRename: (type: 'organization' | 'workspace' | 'board', id: string, newName: string) => void;
  onDelete: (type: 'organization' | 'workspace' | 'board', id: string) => void;
}

export const ManageWorkspaceContent = ({
  organizations,
  onRename,
  onDelete,
}: ManageWorkspaceContentProps) => {
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<{
    type: 'organization' | 'workspace' | 'board';
    id: string;
    name: string;
  } | null>(null);
  const [newName, setNewName] = useState("");

  const handleItemAction = (
    action: 'rename' | 'delete',
    type: 'organization' | 'workspace' | 'board',
    id: string,
    name: string
  ) => {
    setSelectedItem({ type, id, name });
    if (action === 'rename') {
      setNewName(name);
      setRenameDialogOpen(true);
    } else {
      setDeleteDialogOpen(true);
    }
  };

  const handleRenameConfirm = () => {
    if (selectedItem) {
      onRename(selectedItem.type, selectedItem.id, newName);
      setRenameDialogOpen(false);
      setSelectedItem(null);
      setNewName("");
    }
  };

  const handleDeleteConfirm = () => {
    if (selectedItem) {
      onDelete(selectedItem.type, selectedItem.id);
      setDeleteDialogOpen(false);
      setSelectedItem(null);
    }
  };

  return (
    <>
      {organizations.map((org) => (
        <OrganizationItem
          key={org.id}
          organization={org}
          onRename={(type, id, name) => handleItemAction('rename', type, id, name)}
          onDelete={(type, id, name) => handleItemAction('delete', type, id, name)}
        />
      ))}

      <RenameItemDialog
        isOpen={renameDialogOpen}
        onOpenChange={setRenameDialogOpen}
        itemType={selectedItem?.type || 'organization'}
        currentName={selectedItem?.name || ''}
        onConfirm={handleRenameConfirm}
        value={newName}
        onChange={setNewName}
      />

      <DeleteItemDialog
        isOpen={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        itemType={selectedItem?.type || 'organization'}
        itemName={selectedItem?.name || ''}
        onConfirm={handleDeleteConfirm}
      />
    </>
  );
};